import { ORDERS_HISTORY_PAGE as dict } from '@/resources/dict'
import { HexaIcons } from './hexaIcons'

export const deliveryTypeEnum = Object.freeze({
  RECEIVE: 'RECEIVE',
  SCHEDULED: 'SCHEDULED',
  PICKUP: 'PICKUP',
  TURBO: 'TURBO',
  ECONOMY: 'ECONOMY',
})

export enum DeliveryType {
  RECEIVE = 'RECEIVE',
  SCHEDULED = 'SCHEDULED',
  PICKUP = 'PICKUP',
  TURBO = 'TURBO',
  ECONOMY = 'ECONOMY',
}

export const ECONOMY_DELIVERY_TYPE_VALUE = 'Economy'

type DeliveryTypeLabelsDict = {
  receive: string
  scheduled: string
  pickup: string
  turbo: string
  economy: string
}

const deliveryTypesDict = dict.deliveryTypes as DeliveryTypeLabelsDict

export const deliveryTypeLabel = {
  [DeliveryType.RECEIVE]: deliveryTypesDict.receive,
  [DeliveryType.SCHEDULED]: deliveryTypesDict.scheduled,
  [DeliveryType.PICKUP]: deliveryTypesDict.pickup,
  [DeliveryType.TURBO]: deliveryTypesDict.turbo,
  [DeliveryType.ECONOMY]: deliveryTypesDict.economy,
}

export const deliveryTypeIcon = {
  RECEIVE: HexaIcons.CHECKMARK_3,
  SCHEDULED: HexaIcons.CLOCK,
  PICKUP: HexaIcons.BASKET,
  TURBO: HexaIcons.ZAP,
  ECONOMY: HexaIcons.CURRENCY,
} as const
